module.exports = __webpack_public_path__ + "static/media/system.9072e608.svg";